import React, { Component } from 'react';
import { FormControl, FormLabel, FormControlLabel, RadioGroup, Radio } from '@mui/material';

const filterSpacingStyle = { width: '100%', marginRight: '2rem' };

class RadioInput extends Component {
  constructor(props) {
    super(props);
    this.state = { value: props.query[props.settings.key] || props.settings.defaultValue };

    this.onChange = this.onChange.bind(this);
  }

  componentWillMount() {
    this.handleNotification();
  }

  componentWillReceiveProps(props) {
    let newValue = props.query[props.settings.key] || props.settings.defaultValue;
    if (newValue != this.state.value) {
      this.setState({ ...this.state, value: newValue });
    }
  }

  onChange = (newValue) => {
    this.setState({ ...this.state, value: newValue.target.value }, () => this.handleNotification());
  };

  handleNotification = () => {
    if (this.isQueryDifferentFromState()) {
      this.props.onChanged(
        {
          [this.props.settings.key]: this.state.value,
        },
        this.props.settings
      );
    }
  };

  isQueryDifferentFromState = () => {
    return !this.state || this.state.value != this.props.query[this.props.settings.key];
  };

  render() {
    return (
      <FormControl
        variant="standard"
        component="fieldset"
        style={filterSpacingStyle}
        data-qa={`qa-rbFilter-${this.props.settings.name}`}
      >
        <FormLabel component="label">
          <p style={{ fontSize: '75%' }}>{this.props.settings.displayName}</p>
        </FormLabel>
        <RadioGroup
          className="u-fx u-fx-align-center"
          name="table"
          value={this.state.value}
          onChange={this.onChange}
          row
        >
          {this.props.settings.options.map((option, index) => (
            <FormControlLabel
              key={index}
              value={option.value}
              control={<Radio color="primary" />}
              label={option.name}
              data-qa={`qa-${option.value}`}
            />
          ))}
        </RadioGroup>
      </FormControl>
    );
  }
}

export default RadioInput;
